import { z } from "zod";

export const payReferralSchema = () => {
  return z.object({
    custom_value_paid: z
      .union([z.number().positive(), z.nan(), z.undefined()])
      .optional()
      .nullable(),
  });
};

export type PayReferralFormValues = z.infer<ReturnType<typeof payReferralSchema>>;
